import { AUTHOR_ROLE, WidgetMessage } from "@/api/types";

export const getIsIAmSender = (
  message: WidgetMessage,
) => {
  return message.author.role === AUTHOR_ROLE.VISITOR
};